import { useContext, ReactNode } from 'react';
import { BannerContext } from 'app/agriculture/contexts/BannerContextProvider';
import './Banner.scss';
import { Collapse } from '@mui/material';
import { createPortal } from 'react-dom';

interface BannerContentProps {
    isOpen?: boolean;
    children: ReactNode;
}

export function BannerContent({ isOpen = true, children }: BannerContentProps) {
    const { bannerRef } = useContext(BannerContext);

    if (!bannerRef) {
        return null;
    }

    return (
        <>
            {createPortal(
                <Collapse in={isOpen}>
                    <div className="banner">{children}</div>
                </Collapse>,
                bannerRef,
            )}
        </>
    );
}
